import config from '../../config';
import Component from '../Component';
import Lookup from './Lookup';
import React from 'react';

export default class OrderLookup extends Component {

	api(q, page) {
		const client = config.getApiClient;
		return client.call('order.lookup', {q: q, page: page});
	}

	render() {
		return <Lookup query={(q, page) => this.api(q, page)} {...this.props} />
	}
}


// WEBPACK FOOTER //
// ./src/components/Form/OrderLookup.js